<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <AdaptiveImage class="core-strengths-grid-bg" is-background :field="fields?.backgroundImage">
        <JssRichText :field="fields?.title" class="core-strengths-grid-title" tag="h2" />
        <div class="core-strengths-grid-list">
          <div
            class="core-strengths-grid-list-item"
            v-for="item in fields?.list"
            :key="item?.title"
          >
            <Icon
              :svg="item?.fields?.icon?.value?.svgCode"
              class="core-strengths-grid-list-item-icon"
            />
            <JssRichText :field="item?.fields?.desc" class="core-strengths-grid-list-item-desc" />
          </div>
        </div>
      </AdaptiveImage>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'CoreStrengthsGrid',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() =>
      utils.overall.baseComClass(props.fields, 'core-strengths-grid')
    );

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.core-strengths-grid {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-bg {
    .e-background-image__content {
      padding: 24px;
    }
  }

  &-title {
    text-align: center;
  }

  &-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      &-icon {
        width: 52px;
        height: 52px;

        svg {
          width: 52px;
          height: 52px;
        }
      }

      &-desc {
        font-size: 18px;
        line-height: 1.6;
        color: #4b5563;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-bg {
      .e-background-image__content {
        padding: 60px 80px;
      }
    }

    &-list {
      margin-top: 60px;
      flex-direction: row;

      &-item {
        padding: 0 32px;
        flex: 1;
        border-right: 1px solid #abbcac;
        align-items: flex-start;

        &:last-child {
          border-right: none;
        }
      }
    }
  }
}
</style>
